import { PromotionNotAvailablePageLabels } from 'libs/shared-lib/interfaces';

export const PROMOTION_NOT_AVAILABLE_LABELS_IT: PromotionNotAvailablePageLabels = {
    headline: 'Sembra che ci sia un problema.',
    copyFirst: 'Siamo spiacenti, ma non è stato possibile trovare la promozione. Potrebbe essere scaduta.',
    copySecond: 'Qui trovi tutte le offerte attuali.',
};
